import { useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/molecules/Button";
import {
  DEV_MONITOR,
  QA_MONITOR,
  MAIN_MONITOR,
  QA,
  MAIN,
} from "@/common/CommonConstants";

type CustomLocation = {
  state: { redirect: boolean; message: string };
};

export const AuthError = () => {
  const navigate = useNavigate();
  const location: CustomLocation = useLocation() as CustomLocation;
  const goToMenu = useCallback(() => navigate(`/`), [navigate]);
  const reLogin = () => {
    const root = window.location.href.replace("auth-error", "");
    window.location.href = root;
  };

  const url = () => {
    return process.env.REACT_APP_PROD_URL === MAIN
      ? MAIN_MONITOR
      : process.env.REACT_APP_PROD_URL === QA
        ? QA_MONITOR
        : DEV_MONITOR;
  };

  return (
    <div>
      <h3>{location.state.message}</h3>
      {location.state.redirect && (
        <a target="_blank" rel="noopener noreferrer" href={url()}>
          {url()}
        </a>
      )}
      <Button
        label={location.state.redirect ? "再ログイン" : "メニューに戻る"}
        sx={{ backgroundColor: "#4CAF50", ml: 3 }}
        onClick={location.state.redirect ? reLogin : goToMenu}
      />
    </div>
  );
};
